var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640 256C640 260.406 636.406 264 632 264H512C498.781 264 488 274.781 488 288V416C488 438.062 470.062 456 448 456H352C329.938 456 312 438.062 312 416V96C312 82.781 301.219 72 288 72H192C178.781 72 168 82.781 168 96V224C168 246.062 150.062 264 128 264H8C3.594 264 0 260.406 0 256S3.594 248 8 248H128C141.219 248 152 237.219 152 224V96C152 73.938 169.938 56 192 56H288C310.062 56 328 73.938 328 96V416C328 429.219 338.781 440 352 440H448C461.219 440 472 429.219 472 416V288C472 265.938 489.938 248 512 248H632C636.406 248 640 251.594 640 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveSquare);
export default __webpack_public_path__ + "static/media/wave-square.272afe5e82d0a1d4ec172cd16aced35e.svg";
export { ForwardRef as ReactComponent };